export default {
  schema: {
    fields: [
      {
        type: 'radios',
        label: `
          Do you plan on adding additional equity to the deal by cross collateralizing
          with additional properties?
        `,
        required: true,
        styleClasses: 'col-md-12 bool-radio',
        values: [
          { name: 'Yes', value: true },
          { name: 'No', value: false },
        ],
      },
    ],
  },
  formOptions: {
    validationErrorClass: 'invalid-input',
    validateAfterChanged: false,
    fieldIdPrefix: 'crosses-',
  },
};



// WEBPACK FOOTER //
// ./src/components/new_deal/components/property/crosses/schema.js